window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ce-tabs').length) {
    import('./_tabs.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}
